// =============== promo announcement bar copy code js
const codecopy = document.querySelector(".copy-code-right");
const closeicons = document.querySelector(".discount-bar-close-icon");
const mainClass = document.querySelector(".coupan-code");
if (codecopy) {
  codecopy.addEventListener("click", function () {
    let copyText = document.querySelector(".copy-code-left").innerText;

    let tempTextArea = document.createElement("textarea");
    tempTextArea.value = copyText;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
  });
}
closeicons?.addEventListener("click", function () {
  mainClass.classList.remove("close-bar");
});


// Header Transparent JS
(function() {
  const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(header_operlay){
    document.body.classList.add('header-overlay');
  } 
})();

// Initialize AOS JS
AOS.init();

// start mobile menu close

class DrawerClose extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    this.closest('details').querySelector('summary').click();
  }
}

 // <drawer-close>
 //   <a href="javascript:void(0);"class="close-icon" id="mobile_menu_click">text</a>
 // </drawer-close>

customElements.define('drawer-close', DrawerClose);


// product tab logic

document.querySelectorAll('.tab-button').forEach(btn => {
  btn.addEventListener('click', function() {

    // Remove old active states
    document.querySelectorAll('.tab-button').forEach(b => b.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

    // Add new active states
    this.classList.add('active');
    document.getElementById(this.dataset.tab).classList.add('active');
  });
});

// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");

  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    if (!content) return;
    accordion.classList.add("active");
    content.style.maxHeight = "max-content";
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    if (!content) return;
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");

    if (intro && content) {
      intro.addEventListener("click", (e) => {
        const currentAccordion = e.target.closest("[js-acc-item]");

        if (currentAccordion.classList.contains("active")) {
          closeAccordion(currentAccordion);
          return;
        }

        accordions.forEach((acc) => closeAccordion(acc));
        openAccordion(currentAccordion);
      });
    }
  });
}

// Run accordion setup
(function () {
  faq_taggol();
})();


// Faq page wirkung img hide show

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-faq-section]').forEach(section => {
    const detailsEls = section.querySelectorAll('details');
    const images = section.querySelectorAll('.faq-image');

    detailsEls.forEach(details => {
      details.addEventListener('toggle', () => {

        // Only when THIS details is opened
        if (!details.open) return;

        const blockId = details.id.replace('Details-', '').split('-')[0];

        // Close other FAQs in SAME section
        detailsEls.forEach(d => {
          if (d !== details) d.removeAttribute('open');
        });

        // Hide images only in this section
        images.forEach(img => {
          img.style.display = 'none';
        });

        // Show related image
        const activeImg = section.querySelector(
          `.faq-image[data-block-id="${blockId}"]`
        );

        if (activeImg) {
          activeImg.style.display = 'block';
        }
      });
    });
  });
});

window._trusted = window._trusted || [];

window._trusted.push([
    'trustedStars',
    {
      style: {
        margin: '0'
      }
    }
  ]);